module.exports = __webpack_public_path__ + "static/media/jacuzzi-dark-gray.fd71f08b.svg";